<template>
  <app-launcher-warning
    :app-state="appState"
    :app-error="appError"
    :v-suggest="vSuggest"
    :v-target="updateTargetVersion"
    :is-updating="isPreparingInstall"
    :is-loading="isSavingSettings"
    :is-user-an-admin="isUserAdmin"
    @app-install="onUpdateToMaxAppVersion"
    @app-update="onUpdateToMaxAppVersion"
    @accept-version="onAcceptVersion"
    @retry-update="onRetryAppUpdate"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherWarning from '../components/AppLauncherWarning.vue';
import { useAppLauncher, useCommonActions, useAppUpdate } from '../composables';

export default defineComponent({
  name: 'AppLauncherWarningContainer',
  components: { AppLauncherWarning },
  setup() {
    const {
      appState,
      appError,
      updateTargetVersion,
      vSuggest,
      isPreparingInstall,
      isSavingSettings,
      isUserAdmin,
    } = useAppLauncher();
    const { onUpdateToMaxAppVersion, onRetryAppUpdate } = useAppUpdate();
    const { onAcceptVersion } = useCommonActions();

    return {
      appState,
      appError,
      updateTargetVersion,
      vSuggest,
      isPreparingInstall,
      isSavingSettings,
      isUserAdmin,
      onAcceptVersion,
      onUpdateToMaxAppVersion,
      onRetryAppUpdate,
    };
  },
});
</script>
